import {
    REQUEST_PROMOTIONS,
    FETCH_PROMOTIONS_SUCCESS,
    FETCH_PROMOTIONS_FAILURE,
    SELECT_PROMOTIONS,
    RESET_CURRENT_PROMOTIONS,
    REQUEST_PROMOTIONS_DETAIL,
    FETCH_PROMOTIONS_DETAIL_SUCCESS,
    FETCH_PROMOTIONS_DETAIL_FAILURE,
    REQUEST_ADDING_PROMOTION,
    ADD_PROMOTION_SUCCESS,
    ADD_PROMOTION_FAILURE,
    REQUEST_DELETE_PROMOTION,
    DELETE_PROMOTION_SUCCESS,
    DELETE_PROMOTION_FAILURE,
    REQUEST_EDITING_PROMOTION,
    EDIT_PROMOTION_SUCCESS,
    EDIT_PROMOTION_FAILURE,
    REQUEST_SAVE_PROMO_NOTES,
    SAVE_PROMO_NOTES_SUCCESS,
    SAVE_PROMO_NOTES_FAILURE,
    REQUEST_PROMO_NOTES,
    FETCH_PROMO_NOTES_SUCCESS,
    FETCH_PROMO_NOTES_FAILURE,
    CLEAR_PROMO_NOTES_STATUS,
    SET_CURRENT_PROMO,
    RESET_CURRENT_PROMO,
    REQUEST_PROMO_DETAILS,
    FETCH_PROMO_DETAILS_SUCCESS,
    FETCH_PROMO_DETAILS_FAILURE,
    REQUEST_SAVE_PROMOTION,
    SAVE_PROMOTION_SUCCESS,
    CLEAR_PROMO_DETAIL_STATUS,
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentPromotions: null,
    currentPromotionsDetail: null,
    isLoading: false,
    error: null,
    promotionsAreLoading: false,
    promotionsError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    addError: null,
    addPromotionSuccess: false,
    editIsLoading: false,
    editPromotionSuccess: false,
    editError: null,
    promoNotes: null,
    promoNotesIsLoading: false,
    promoNotesError: null,
    savePromoNotesSuccess: null,
    currentPromo: null,
    savingPromotion: false,
    promotionDetails: null,
    promotionDetailsIsLoading: false,
    promotionDetailsError: null,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Promotions action handlers
        case REQUEST_PROMOTIONS:
            return { ...state, error: null, all: [], isLoading: true };
        case FETCH_PROMOTIONS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false, addPromotionSuccess: false, editPromotionSuccess: false };
        case FETCH_PROMOTIONS_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_PROMOTIONS:
            return { ...state, currentPromotions: action.payload };
        case RESET_CURRENT_PROMOTIONS:
            return { ...state, currentPromotions: null, currentPromotionsDetail: null, addPromotionSuccess: false, editPromotionSuccess: false };
        case REQUEST_PROMOTIONS_DETAIL:
            return { ...state, promotionsError: null, promotionsAreLoading: true };
        case FETCH_PROMOTIONS_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentPromotionsDetail: action.payload, promotionsError: null, promotionsAreLoading: false };
        case FETCH_PROMOTIONS_DETAIL_FAILURE:// return error and make loading = false
            const promotionsError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], promotionsError: promotionsError, promotionsAreLoading: false };
        case REQUEST_ADDING_PROMOTION:
            return { ...state, addError: null, isLoading: true};
        case ADD_PROMOTION_SUCCESS:
            return { ...state, isLoading: false, addPromotionSuccess: true };
        case ADD_PROMOTION_FAILURE:
            const addError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, addError: addError, isLoading: false };
        case REQUEST_EDITING_PROMOTION:
            return { ...state, editError: null, editIsLoading: true};
        case EDIT_PROMOTION_SUCCESS:
            return { ...state, editIsLoading: false, editPromotionSuccess: true };
        case EDIT_PROMOTION_FAILURE:
            const editError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, editError: editError, editIsLoading: false };
        case REQUEST_DELETE_PROMOTION:
            return { ...state, error: null, isLoading: true};
        case DELETE_PROMOTION_SUCCESS:
            return { ...state, isLoading: false};
        case DELETE_PROMOTION_FAILURE:
            return { ...state, error: error, isLoading: false};
        case REQUEST_PROMO_NOTES:
            return { ...state, promoNotesIsLoading: true, promoNotesError: null };
        case FETCH_PROMO_NOTES_SUCCESS:
            return { ...state, promoNotesIsLoading: false, promoNotes: action.payload.data };
        case FETCH_PROMO_NOTES_FAILURE:
            const promoNotesError = action.payload.data || { message: action.payload.message };
            return { ...state, promoNotesIsLoading: false, promoNotesError };
        case SAVE_PROMO_NOTES_SUCCESS:
            return { ...state, savePromoNotesSuccess: true };
        case SAVE_PROMO_NOTES_FAILURE:
            const savePromoNotesError = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(savePromoNotesError));
            return { ...state, savePromoNotesSuccess: false };
        case CLEAR_PROMO_NOTES_STATUS:
            return { ...state, savePromoNotesSuccess: null };
        case SET_CURRENT_PROMO:
            return { ...state, currentPromo: action.payload.data };
        case RESET_CURRENT_PROMO:
            return { ...state, currentPromo: null };
        case REQUEST_PROMO_DETAILS:
            return { ...state, promotionDetailsIsLoading: true, promotionDetails: null, promotionDetailsError: null };
        case FETCH_PROMO_DETAILS_SUCCESS:
            return { ...state, promotionDetailsIsLoading: false, promotionDetails: action.payload.data };
        case FETCH_PROMO_DETAILS_FAILURE:
            const promotionDetailsError = action.payload.data || { message: action.payload.message };
            return { ...state, promotionDetailsIsLoading: false, promotionDetails: null, promotionDetailsError };
        case SAVE_PROMOTION_SUCCESS:
            return { ...state, promotionDetailsError: null, savingPromotion: false };
        case REQUEST_SAVE_PROMOTION:
            return { ...state, promotionDetailsError: null, savingPromotion: true };
        case CLEAR_PROMO_DETAIL_STATUS:
            return { ...state, promotionDetailsError: null };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/promotions_reducer.jsx